// volunteers.js
// Firebase volunteers collection API functions

import { 
  collection, 
  doc, 
  getDoc, 
  getDocs, 
  addDoc, 
  updateDoc, 
  deleteDoc,
  serverTimestamp,
  query,
  where,
  orderBy
} from 'firebase/firestore';
import { db } from '../firebaseConfig';

const VOLUNTEERS_COLLECTION = 'volunteers';

/**
 * Get all volunteers
 */
export const getAllVolunteers = async () => {
  try {
    const volunteersRef = collection(db, VOLUNTEERS_COLLECTION);
    const q = query(volunteersRef, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    const volunteers = [];
    querySnapshot.forEach((doc) => {
      volunteers.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    
    return volunteers;
  } catch (error) {
    console.error('Error getting volunteers:', error);
    throw error;
  }
};

/**
 * Register volunteer for event
 */
export const registerVolunteer = async (eventId, userId, volunteerData) => {
  try {
    const volunteersRef = collection(db, VOLUNTEERS_COLLECTION);
    
    const newVolunteer = {
      eventId,
      userId,
      ...volunteerData,
      status: 'pending',
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };

    const docRef = await addDoc(volunteersRef, newVolunteer);
    
    return {
      id: docRef.id,
      ...newVolunteer,
    };
  } catch (error) {
    console.error('Error registering volunteer:', error);
    throw error;
  }
};

/**
 * Get volunteers for event
 */
export const getEventVolunteers = async (eventId) => {
  try {
    const volunteersRef = collection(db, VOLUNTEERS_COLLECTION);
    const q = query(volunteersRef, where('eventId', '==', eventId));
    const querySnapshot = await getDocs(q);
    
    const volunteers = [];
    querySnapshot.forEach((doc) => {
      volunteers.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    
    return volunteers;
  } catch (error) {
    console.error('Error getting event volunteers:', error);
    throw error;
  }
};

/**
 * Get user's volunteer history
 */
export const getUserVolunteerHistory = async (userId) => {
  try {
    const volunteersRef = collection(db, VOLUNTEERS_COLLECTION);
    const q = query(volunteersRef, where('userId', '==', userId));
    const querySnapshot = await getDocs(q);
    
    const volunteers = [];
    querySnapshot.forEach((doc) => {
      volunteers.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    
    return volunteers;
  } catch (error) {
    console.error('Error getting volunteer history:', error);
    throw error;
  }
};

/**
 * Update volunteer status
 */
export const updateVolunteerStatus = async (volunteerId, status) => {
  try {
    const volunteerRef = doc(db, VOLUNTEERS_COLLECTION, volunteerId);
    
    await updateDoc(volunteerRef, {
      status,
      updatedAt: serverTimestamp(),
    });
    
    return { id: volunteerId, status };
  } catch (error) {
    console.error('Error updating volunteer status:', error);
    throw error;
  }
};

/**
 * Delete volunteer registration
 */
export const deleteVolunteer = async (volunteerId) => {
  try {
    const volunteerRef = doc(db, VOLUNTEERS_COLLECTION, volunteerId);
    await deleteDoc(volunteerRef);
  } catch (error) {
    console.error('Error deleting volunteer:', error);
    throw error;
  }
};

/**
 * Get volunteer by ID
 */
export const getVolunteerById = async (volunteerId) => {
  try {
    const volunteerDoc = await getDoc(doc(db, VOLUNTEERS_COLLECTION, volunteerId));
    
    if (volunteerDoc.exists()) {
      return {
        id: volunteerDoc.id,
        ...volunteerDoc.data(),
      };
    } else {
      throw new Error('Volunteer not found');
    }
  } catch (error) {
    console.error('Error getting volunteer:', error);
    throw error;
  }
};

